import React from 'react';
import "./flap-header.scss";

export const FlapHeader = (props) => {

    const { primary, justify, leftSide, rightSide, className } = props;

    return (
        <div className={
            `nav d-flex justify-content-between px-4 
            ${primary ?
                "custom-primary-nav-header" :
                "custom-secondary-nav-header"} 
                ${justify ?
                "py-2" :
                "py-1"} ${className}`} >
            {leftSide}
            {rightSide}
        </div>
    );
}

